<template>
  <v-list-item
    class="list-item ps-1 pe-3 py-0"
    data-testid="list-item"
    :key="item.id"
    @click="$emit('click', item)"
  >
    <v-list-item-avatar
      v-if="!hideIcon"
      class="d-flex justify-center ma-0 align-center"
    >
      <div
        class="rounded-circle blue-grey lighten-3"
        style="height: 24px; width: 24px"
      >
        <v-icon size="16" color="blue-grey darken-1">{{ item.icon }}</v-icon>
      </div>
    </v-list-item-avatar>

    <v-list-item-content class="pt-1 pb-1">
      <div class="d-flex align-center justify-space-between overflow-hidden">
        <div class="flex-grow-0 flex-shrink-1 overflow-hidden">
          <v-list-item-title class="font-size-13 name">
            <text-highlight
              highlightClass="yellow lighten-1"
              data-private
              highlightComponent="span"
              :queries="searchTerm || ''"
            >
              {{ itemTitle }}
            </text-highlight>
          </v-list-item-title>
          <p class="ma-0 font-size-10 blue-grey--text subtitle">
            {{ item.subtitle }}
          </p>
        </div>

        <v-icon
          v-if="selected"
          class="flex-grow-0 flex-shrink-0 ml-1"
          color="blue"
          size="20"
          >mdi-check-circle</v-icon
        >
      </div>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  name: 'ListItem',

  props: {
    item: Object,
    searchTerm: String,
    selected: Boolean,
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    itemTitle() {
      return this.item.title ?? ''
    },
  },
}
</script>

<style scoped lang="scss">
.name {
  line-height: 20px !important;
}

.subtitle {
  line-height: 16px !important;
}

.list-item.v-list-item::before,
.list-item.v-list-item:hover {
  border-radius: 4px !important;
  background-color: $color-blue-grey-lighten3;
}
</style>
